<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">

                <!-- Header of the modal -->
                <div class="modal-header">
                    <slot name="header">
                        <h3>Ticket erstellen</h3>
                        {{ event.name }} - {{ event.city }}
                        <div v-if="error" class="alert alert-danger" role="alert">
                            {{ error }}
                        </div>
                    </slot>
                </div>
                <div class="modal-body">   
                    <div class="row">
                        <div class="col-12">
                            <slot name="body">
                                <div class="form-group row">
                                    <div class="col-3">
                                        <label for="price">Preiskategorie</label>
                                        <select class="form-control form-select form-select-lg mb-3" name="price" v-model="category">
                                            <option selected>auswählen</option>
                                            <option v-for="category in event.pricecategories" :key="category.id" :value="category.id">{{ category.name }} - {{ category.price }}€</option>
                                        </select>
                                    </div>
                                    <!--<div class="col-3 text-center">
                                        <label class="form-check-label" for="personalized">Personalisiert?</label><br>
                                        <input class="form-check-input m-0" type="checkbox" name="personalized" v-model="personalized" />
                                    </div>
                                    <div class="col-6">
                                        <label for="name">Besuchername</label>
                                        <input class="form-control" type="text" name="name" v-model="name" :disabled="!personalized" />
                                    </div>-->
                                </div>
                                <div class="form-group row">
                                    <div class="col-3">
                                        <label for="type">Art des Platzes</label>
                                        <select class="form-control form-select form-select-lg mb-3" name="type" v-model="type">
                                            <option selected>auswählen</option>
                                            <option value="3">benutzerdefiniert</option>
                                            <option value="1" selected>bestuhlt, freie Platzwahl</option>
                                            <option value="4">freie Platzwahl</option>
                                            <option value="2">Stehplatz</option>
                                        </select>
                                    </div>
                                    <div class="col-3" v-if="type == 3">
                                        <label for="block">Block</label>
                                        <input class="form-control" type="text" v-model="block" name="block" />
                                    </div>
                                    <div class="col-3" v-if="type == 3">
                                        <label for="row">Reihe</label>
                                        <input class="form-control" type="text" v-model="row" name="row" />
                                    </div>
                                    <div class="col-3" v-if="type == 3">
                                        <label for="seat">Sitz</label>
                                        <input class="form-control" type="text" v-model="seat" name="seat" />
                                    </div>
                                </div>
                            </slot>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <slot name="footer">
                        <button class="btn btn-outline-danger" @click="$emit('TicketModalClosed')">Abbrechen</button>
                        <button class="btn btn-success" @click="addTicket(false)" :disabled="!valid">Speichern</button>
                        <button class="btn btn-primary" @click="addTicket(true)" :disabled="!valid">Speichern & PDF erstellen</button>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: "TicketModal",
    props: {
        event: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            category: null,
            type: null,
            block: null,
            row: null,
            seat: null,
            personalized: false,
            name: null,
            error: "",
        }
    },
    methods: {
        addTicket (p) {
            this.error = "";
            axios.post(process.env.VUE_APP_BACKEND + '/api/tickets', {
                eventid: this.event.id,
                pricecategoryid: this.category,
                type: parseInt(this.type),
                block: this.block,
                row: this.row,
                seat: this.seat,
            },{
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response) => {
                if (p) {
                    var url = process.env.VUE_APP_BACKEND + '/api/tickets/' + response.data.id + '/print'
                    window.open(url, '_self').focus()
                }
                this.$emit('TicketModalSaved') 
            }).catch((e) => {
                this.error = e.response.data.message
            })         
        },
    },
    computed: {
        valid() {
            if (this.category && this.type == 3 && this.block && this.row && this.seat) {
                return true
            } else if (this.category && this.type && this.type != 3) {
                return true
            } else {
                return false
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 1000px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  font-family: Helvetica, Arial, sans-serif;
}

.modal-body {
  margin: 20px 0;
}

input[type=checkbox], input[type=radio] {
    width: 2.5rem;
    height: 2.5rem;
}

</style>